/* eslint prettier/prettier: 0 */
import type {Translation} from '../i18n-types';

const fr: Translation = {
  ACCEPT_POLICY_FIRST:
    "Veuillez d'abord accepter la politique de suppression de compte",
  ACCOUNT_DELETION_CONFIRMATION: 'Confirmer la suppression du compte',
  ACCOUNT_DELETION_NOTE:
    'Votre compte sera complètement supprimé dans 30 jours. \n\nPendant cette période de 30 jours, vous pouvez annuler la suppression programmée du compte en vous connectant à votre compte AFi.\n\nAprès la suppression de votre compte, certaines données peuvent être conservées pour se conformer aux lois et réglementations financières. Vous pouvez en savoir plus dans la AFi ',

  ACCOUNT_DETAILS: 'Détails du compte',
  ACCOUNT_HOLDER_NAME: 'Nom du propriétaire du compte',
  ACCOUNT_NUMBER: 'Numéro du compte',
  ACCOUNT_SAFE_SMS_CONFIRM:
    "Pour assurer la sécurité de votre compte, nous vous avons envoyé un code par SMS pour confirmer qu'il s'agit bien de vous.",
  ACCOUNT_TYPE: 'Type de compte',
  ACCOUNTS: 'Comptes',
  ACTIVE: 'Actif',
  ADD_A_FINANCIAL_ACCOUNT: 'Ajouter un compte',
  ADD_A_PERSON_OR_BUSINESS: 'Ajouter une personne ou une entreprise',
  ADD_A_RECIPIENT: 'Ajouter un bénéficiaire',
  ADD_ACCOUNT: 'Ajouter un compte',
  ADD_FINANCIAL_ACCOUNT: 'Ajouter un compte financier',
  ADD_ID: "Ajouter la pièce d'identité",
  ADD_SENDER: 'Ajouter un expéditeur',
  ADDRESS: 'Adresse',
  ADDRESS_LINE_1: 'Adresse 1',
  ADDRESS_LINE_2: 'Adresse 2',
  ADDRESS_REQUIRED: 'Adresse requise',
  AFI_USER_AREEMENT: 'ACCORD UTILISATEUR AFI',
  AMOUNT: 'Montant',
  AMOUNT_PAID_FEES_INCLUDED: 'Montant payé (frais inclus)',
  AMOUNT_REQUESTED: 'Montant demandé',
  AMOUNT_RECEIVED: 'Montant reçu',
  AMOUNT_SENT: 'Montant envoyé',
  AND: 'et',
  ANSWER: 'Réponse',
  APPROVED: 'Approuvé',
  ARE_YOU_SURE_TO_CANCEL_PAYMENT:
    'Êtes-vous sûr de vouloir annuler ce paiement?',
  ARE_YOU_SURE_YOU_WANT: 'Êtes-vous sûr de vouloir annuler cette demande?',
  ATLEAST_CHARACTERS_CONTAINING: 'Au moins 8 caractères contenant',
  BACK: 'Retour',
  BACKUP_OPTIONS:
    "Ce sont vos options de secours si jamais vous perdez l'accès à votre courrier électronique et/ou à votre téléphone.",
  BALANCE: 'Solde',
  BANK_ACCOUNT: 'Compte bancaire',
  BANK_CARD: 'Carte de débit / crédit',
  BANK_NAME: 'Nom de la banque',
  BULK_MODE: 'Mode groupé',
  BULK_PAYMENT_REQUEST: 'Demande de paiement groupé',
  BILLS: 'Factures',
  BUSINESS_INFO: "Informations sur l'entreprise",
  BUSINESS_NAME: "Nom de l'entreprise",
  CAMERA_PERMISSION_COULD_NOT_BE_REQUESTED:
    "L'autorisation de la caméra n'a pas pu être demandée. Afin de poursuivre, veuillez vous rendre dans les paramètres de l'application et accorder manuellement l'autorisation de la caméra.",
  CANCEL_PAYMENT: 'Annuler le paiement',
  CANCEL_REQUEST: 'Annuler la demande',
  CANNOT_CREATE_PREFUND_ACCOUNTS:
    'Vous ne pouvez pas utiliser les fonctionnalités du compte de préfinancement.  Veuillez contacter "AFi support" pour obtenir de l\'aide. Merci',
  CANNOT_INITIATE_TRANSACTION:
    "Vous ne pouvez pas initier de transactions. Veuillez contacter le AFi support pour plus d'assistance.",
  CARD_NUMBER: 'Numéro de carte ',
  CATEGORY: 'Catégorie',
  CATEGORY_MISSING_ERROR: 'Veuillez sélectionner une catégorie',
  CERTIFICATE_OF_INCORPORATION: "Certificat d'incorporation",
  CERTIFICATE_TO_COMMERCE: 'Certificat de commerce',
  CHANGE_EMAIL: "Changer l'adresse email",
  CHANGE_ID: "Changer la pièce d'identité",
  CHANGE_PERSONAL_INFO: 'Modifier les informations personnelles',
  CHANGE_PHONE_NUMBER: 'Changer de numéro de téléphone\n',
  CHANGE_YOU_PASSWORD_REGULARY:
    'Changez régulièrement votre mot de passe pour assurer la sécurité de votre compte.',
  CHOOSE_PASSWORD: 'Choisissez un mot de passe',
  CHOOSE_YOUR_LANGUAGE: 'Choisissez votre langue',
  CHOOSE_YOUR_PREFERRED_LANGUAGE: 'Choisissez votre langue préférée',
  CITY: 'Ville',
  CITY_REQUIRED: 'Ville requise',
  CLICK_THE_LINK_SENT_TO_THIS_NEW_EMAIL_ADDRESS:
    'Cliquez sur le lien envoyé à cette nouvelle adresse e-mail',
  CLICK_THE_VERIFICATION_BUTTON:
    'Cliquez sur le bouton de vérification pour commencer',
  CONFIRM_ACCOUNT_DETAILS:
    "Confirmez que les détails du compte sont exacts. Il n'y a pas de remboursement pour les paiements sur des comptes erronés.",
  CONFIRM_AND_PAY: 'Confirmer et payer',
  CONFIRM_AND_REQUEST: 'Confirmer et demander',
  CONFIRM_NEW_RECOVERY_EMAIL_ADDRESS:
    'Confirmer la nouvelle adresse e-mail de récupération\n',
  CONFIRM_PASSWORD: 'Confirmez le mot de passe',
  CONFIRM_YOUR_IDENTITY: 'Confirmez votre identité',
  CONFIRMATION: 'Confirmation',
  CONFIRMED_DETAILS:
    "Confirmez que les détails du compte sont exacts. Il n'y a pas de remboursement pour les paiements sur des comptes erronés.",
  CONTACT_INFO: 'Info Contact',
  CONTINUE: 'Continuer',
  CONVERSION_RATE: 'Taux de conversion',
  COPY_LINK: 'Copier le lien',
  COUNTRY: 'Pays',
  COUNTRY_REQUIRED: 'Pays requis',
  COUNTRY_THAT_ISSUED_ID: "Pays qui a délivré la carte d'identité",
  CREATE_ACCOUNT: 'Créer un compte',
  CREATE_YOUR_AFI_ACCOUNT: 'Créez votre compte AFi',
  CREATE_FIRST_PREFUND_ACCOUNT: 'Créez votre premier compte de préfinancement',
  CREDIT_DEBIT_CARD_ENDING_IN: 'carte de crédit/débit se terminant par',
  CURRENT_SECURITY_QUESTION: 'Question de sécurité actuelle',
  CURRENCY: 'Devise',
  DATE_OF_BIRTH: 'Date de naissance',
  DAY: 'Jour',
  DAY_REQUIRED: 'Jour requis',
  DECLINED: 'Refusé',
  DELETE_ACCOUNT: 'Supprimer mon compte',
  DESCRIPTION: 'Description',
  DESCRIPTION_MISSING_ERROR: 'La description est requise',
  DIGITAL_ADDRESS: 'Adresse numérique',
  DIGITAL_ADDRESS_REQUIRED: 'Adresse numérique requise',
  DISTRICT_ASSEMBLY_LICENSE: 'permis de la commune',
  DOCUMENTS: 'Documents',
  DOCUMENT_TYPE: 'Type de document',
  DONT_HAVE_AN_ACCOUNT: "Vous n'avez pas de compte?",
  DOWNLOAD: 'Télécharger',
  DOWNLOAD_RECEIPT: 'Télécharger le reçu',
  DOWNLOAD_TEMPLATE: 'Télécharger modèle',
  DRIVERS_LICENSE: 'Permis de conduire',
  DRIVERS_LICENSE_PHOTO: 'Photo du permis de conduire',
  DUE_DATE: "Date d'échéance",
  DUE_DATE_MISSING_ERROR: "Veuillez définir la date d'échéance de la demande",
  EMAIL: 'E-mail',
  EMAIL_ADDRESS: 'Adresse email',
  EMAIL_DID_NOT_ARRIVE: "L' e-mail n'est pas arrivé?",
  EMAIL_NOT_FOUND: 'E-mail {email} introuvable',
  EMAIL_SENT_SUCCESSFULLY: 'E-mail envoyé avec succès!',
  EMAILS_DOES_NOT_MATCH: 'Les e-mails ne correspondent pas',
  ENDING_WITH: 'Se terminant par ****',
  ENTER_AMOUNT: 'Saisir le montant',
  ENTER_AUTHENTIFICATION_CODE: 'Entrez le code de vérification',
  ENTER_CVV: 'Entrez cvv',
  ENTER_NEW_PHONE_NUMBER_ABOVE:
    "Entrez un nouveau numéro de téléphone au-dessus de. Pour assurer la sécurité de votre compte, nous utiliserons un code de vérification pour confirmer qu'il s'agit bien de vous.",
  ENTER_THE_3_DIGITS_AT_THE_BACK_OF_YOUR:
    ' Entrez les 3 chiffres au dos de votre',
  ENTER_THE_SECURITY_CODE_SENT_TO: 'Saisissez le code de sécurité envoyé à :',
  ENTER_YOUR_NEW_EMAIL_ADDRESS:
    "Saisissez votre nouvelle adresse e-mail. Pour aider à protéger votre compte, nous utiliserons un lien de vérification pour confirmer qu'il s'agit bien de vous",
  ENTER_YOUR_NEW_PASSWORD_BELOW: 'Entrez votre nouveau mot de passe ci-dessous',
  ENTER_YOUR_NEW_PHONE_NUMBER:
    "Entrez votre nouveau numéro de téléphone. Pour assurer la sécurité de votre compte, nous utiliserons un code de vérification pour confirmer qu'il s'agit bien de vous.",
  EXPIRATION_DATE: "Date d'expiration",
  EXPIRATION_DATE_MMYY: "Date d'expiration (MM/AA)",
  EXPIRES: 'Expire en',
  EXPORT_AS: 'Exporter en: ',
  FAILED: 'Échoué',
  FEES: 'Frais',
  FINANCIAL_ACCOUNT_REQUIREMENT:
    'La réglementation financière nous oblige à vérifier votre identité. Une fois cette vérification effectuée, vous pouvez envoyer, recevoir et demander des paiements.',
  FINANCIAL_ACCOUNTS: 'Comptes financiers',
  FINANCIAL_REGULATIONS:
    'Les réglementations financières nous obligent à vérifier votre entreprise',
  FINANCIALLY_CONNECTED: 'Financièrement connecté',
  FIRST_NAME: 'Prénom',
  FIRST_NAME_REQUIRED: 'Prénom obligatoire',
  FORGOT_PASSWORD: 'Mot de passe oublié?',
  FORMAT_DAY: 'JJ',
  FORMAT_MONTH: 'MM',
  FORMAT_YEAR: 'AAAA',
  FROM: 'De',
  FROM_DATE: 'De',
  FX_RATES: 'Taux de change',
  GHANA_CARD_PHOTO: "Photo de la carte d'identité",
  GOVERNMENT_ISSUED_ID: "Pièce d'identité délivrée par le gouvernement",
  GRANT_PERMISSIONS: 'Accorder des permissions',
  GROW_YOUR_NETWORK: 'Nouveau contact',
  HELP: 'Aide',
  HI: 'Bonjour {name}! ',
  HOME: 'Accueil',
  HOW_WOULD_YOU_LIKE_TO_PAY: 'Comment voulez-vous payer?',
  HOW_WOULD_YOU_LIKE_TO_PREFUND: 'Comment souhaitez-vous préfinancer?',
  I_AGREE: "Oui, j'accepte.",
  I_WILL_COVER_FEES: 'Je couvre les frais',
  ID_CARD_PHOTO: "Photo de la carte d'identité",
  IDENTITY_VERIFIED: 'Identité vérifiée',
  IF_YOU_ALREADY_HAVE_AN_ACCOUNT: 'si vous avez déjà un compte',
  INVOICE_AMOUNT: 'Montant de la facture',
  INVOICE_DESCRIPTION: 'Description de la facture',
  INVOICE_ISSUED_TO: 'Facture émise à',
  IS_BEING_PROCESSED: 'est en cours de traitement',
  IS_PENDING: 'est en attente',
  KEEP_GOING_WITH_PAYMENT: 'Poursuivre avec le paiement',
  KEEP_GOING_WITH_THE_REQUEST: 'Continuer avec la demande',
  KNOW_THE_RULES:
    "Connaître les règles et directives régissant l'utilisation de AFi.",
  LANGUAGES: 'Langues',
  LAST_NAME: 'Nom',
  LAST_NAME_REQUIRED: 'Nom de famille requis',
  LEGAL: 'Mentions légales',
  LEGAL_NAME: 'Nom complet',
  LINKED_ACCOUNTS: 'Comptes liés',
  LOGOUT: 'Déconnexion',
  LOWER_CASE: 'Minuscule',
  MAKE_ANOTHER_TRANSACTION: 'Faire une autre transaction',
  MANAGE: 'Gérer',
  MAX_AMOUNT_PER_TRANSACTION:
    'Le montant maximum par transaction est: {currencyAmount}',
  METROPOLITAN_LICENSE: 'Licence métropolitaine',
  MIN_AMOUNT_PER_TRANSACTION: 'Le montant minimum par transaction est: {currencyAmount}',
  MOBILE_MONEY: 'Mobile money',
  MONTH: 'Mois',
  MONTH_REQUIRED: 'Mois requis',
  MUNICIPAL_LICENSE: 'Permis municipal',
  MY_NETWORK: 'Mes contacts',
  N_PAYMENT_REQUESTS: '{amount} Demandes de paiement',
  NAME: 'Nom',
  NAME_ON_CARD: 'Nom sur la carte',
  NEW_PREFUND_BALANCE: 'Nouveau solde',
  NEW_RECOVERY_EMAIL_ADDRESS: 'Nouvelle adresse e-mail de récupération',
  NEXT: 'Suivant',
  NO_ACCOUNTS_ADDED_YET: "Aucun compte n'a encore été ajouté",
  NO_RECIPIENTS_FOUND_FOR_THIS_SEARCH:
    'Aucun destinataire trouvé pour cette recherche',
  NO_REFUNDS_TO_WRONG_ACCOUNT:
    "Aucun remboursement n'est effectué pour les paiements envoyés aux comptes erronés",
  NO_TRANSACTIONS_FOUND: 'Aucune transaction trouvée pour cette recherche',
  NUMBER: 'Chiffre',
  OLD_PASSWORD: 'Ancien mot de passe',
  ON_A_REVIEW: 'En révision',
  OOPS_TRANSACTION_UNSUCCESSFUL:
    "Oups ! Cette transaction n'a pas abouti. Contactez l'équipe de support AFi",
  OOPS_NETWORKING_ISSUES:
    'Oups. Il semble que vous ayez un problème de connexion',
  OPERATOR: 'Opérateur',
  OPTION_NOT_AVAILABLE: "Cette option n'est actuellement pas disponible",
  OVERVIEW: 'Aperçu',
  PAGE_NOT_FOUND: 'Page non trouvée !',
  PASSPORT: 'Passeport',
  PASSPORT_PHOTO: 'Photo du passeport',
  PASSWORD: 'mot de passe',
  PASSWORD_CAP: 'Mot de passe',
  PASSWORD_DO_NOT_MATCH: 'Les mots de passe ne correspondent pas',
  PASSWORD_SHOULD_MEET_MINIMUM:
    'Le mot de passe doit répondre aux exigences minimales de sécurité',
  PASSWORD_SHOULD_MEET_REQUIREMENTS:
    'Le mot de passe doit répondre aux exigences minimales de sécurité',
  PASSWORDS_DO_NOT_MATCH: 'Les mots de passe ne correspondent pas',
  PAY: 'Payer',
  PAY_AND_GET_PAID: 'Payer et être payé',
  PAYMENT_CANCELLED_STATUS: 'Annulé',
  PAYMENT_DETAILS: 'Détails du paiement',
  PAYMENT_DRAFT_STATUS: 'Ébauche',
  PAYMENT_EXPIRED_STATUS: 'Expiré',
  PAYMENT_ISSUED_STATUS: 'Délivré',
  PAYMENT_LINK: 'Lien de paiement',
  PAYMENT_PAID_STATUS: 'Payé',
  PAYMENT_PROCESSING_PAYMENT_STATUS: 'Traitement du paiement',
  PAYMENT_REQUEST: 'Demande de paiement',
  PAYMENT_REQUEST_FOR: 'Demande de paiement pour',
  PAYMENT_REQUEST_LINK: 'Lien de demande de paiement',
  PAYMENT_REQUESTS: 'Demandes de paiement',
  PENDING: 'En attente',
  PERSON_OR_BUSINESS_NAME: "Nom de la personne ou de l'entreprise",
  PERSONAL_DETAILS: 'Détails personnels',
  PERSONAL_ID_PLACEHOLDER: "Numéro de pièce d'identité",
  PERSONAL_INFO: 'Info Personelle',
  PHONE_NUMBER: 'Téléphone',
  PLEASE_ACCEPT_THE_TERMS_AND_CONDITOINS:
    'Veuillez accepter les termes et conditions',
  PLEASE_CERTIFY_THAT_YOU_ARE_18_YEARS:
    'Veuillez certifier que vous avez 18 ans ou plus et accepter les',
  PLEASE_CONFIRM_ACCOUNT_DETAILS: 'Veuillez confirmer les détails du compte',
  PLEASE_ENSURE:
    "Veuillez vous assurer d'autoriser la transaction d'argent mobile sur votre téléphone portable.",
  PLEASE_ENSURE_PAYMENT_DETAILS_CORRECT:
    'Veuillez vous assurer que les informations de paiement sont correctes.',
  PLEASE_ENTER_EMAIL: 'Veuillez saisir un e-mail',
  PLEASE_ENTER_OLD_PASSWORD: 'Veuillez entrer votre ancien mot de passe.',
  PLEASE_ENSURE_CORRECT_OTHER_PREFUND_INFO:
    'Veuillez vous assurer que les détails du paiement sont corrects avant de soumettre.',
  PLEASE_FILL_THE_FORM: 'Veuillez remplir ce formulaire',
  PLEASE_PROVIDE_CORRECT_DUE_DATES:
    "Veuillez indiquer des dates d'échéance correctes",
  PLEASE_PROVIDE_NEW_SECURITY_ANSWER:
    'Veuillez fournir une nouvelle réponse de sécurité',
  PLEASE_PROVIDE_REQUEST_AMOUNTS: 'Veuillez indiquer le montant à demander',
  PLEASE_PROVIDE_THE_FOLLOWING_DETAILS: 'Veuillez fournir les détails suivants',
  PLEASE_PROVIDE_THE_OLD_SECURITY_ANSWER:
    "Veuillez fournir l'ancienne réponse de sécurité",
  PLEASE_PROVIDE_THE_REQUIRED_ATTACHMENTS: 'Veuillez fournir les pièces jointes requises',
  PLEASE_WAIT_AND_TRY_AGAIN:
    'Veuillez attendre quelques minutes avant de réessayer',
  PLEASE_SELECT_THE_QUESTION: 'Veuillez sélectionner la question',
  PREFERED_LANGUAGE: 'Langue préférée',
  PREFUND_ACCOUNTS: 'Compte de préfinancement',
  PREFUND_ACCOUNT_NO_TRANSACTION_HISTORY:
    "Ce compte de pré-financement n'a pas d'historique de transactions",
  PREFUND_BALANCE: 'Solde Pré-financer',
  PREFUND_OTHER_NOTICE:
    "Le préfinancement par d'autres moyens prend 1 à 3 jours.  Pour un préfinancement plus rapide, utilisez AFi.",
  PREFUND_USING_AFI: 'Préfinancement via AFi',
  PREFUND_USING_OTHER_WAYS: "Pré-financer utilisant d'autres moyens",
  PRIVACY_POLICY: 'Politique de confidentialité',
  PROFILE: 'Profil',
  PROFILE_LEGAL_NAME: 'Nom complet',
  PROMOTIONAL: 'Promotionnel',
  PURPOSE: 'Motif',
  PURPOSE_OF_PAYMENT: 'Motif du paiement',
  RAPID_SEND: 'Envoi rapide',
  READY_TO_MAKE_YOUR_FIRST_TRANSACTION:
    'Prêt à faire votre première transaction?',
  RECIPIENT: 'Bénéficiaire',
  RECIPIENT_NAME: 'Nom du bénéficiaire',
  RECEIVE: 'Recevoir',
  RECIPIENT_GETS: 'Le bénéficiaire reçoit',
  RECOVERY_EMAIL: 'E-mail de secours',
  RECOVERY_EMAIL_ADDRESS: 'Adresse mail de récupération',
  RECOVERY_EMAIL_ADDRESS_OPTIONAL:
    'Adresse e-mail de récupération (facultatif)',
  RECOVERY_MOBILE_NUMBER: 'Numéro de téléphone de récupération',
  RECOVERY_OPTIONS: 'Options de récupération',
  RECOVERY_PHONE_NUMBER: 'Numéro de téléphone de récupération',
  RECOVERY_PHONE_NUMBER_OPTIONAL:
    'Numéro de téléphone de récupération (facultatif)',
  REFERENCE_CODE: 'Code de référence',
  REFRESH: 'Actualiser',
  REMOVE: 'Supprimer',
  REQUEST: 'Demander',
  REQUEST_A_PAYMENT: 'Demander un paiement',
  REQUEST_FROM: 'Demande de',
  REQUEST_ID: 'ID de la demande',
  REQUEST_YOUR_FIRST_PAYMENT: 'Demandez votre premier paiement',
  REQUESTER_REQUESTED_AMOUNT: '{requesterName} a demandé {currencyAmount}',
  REQUIRED: 'requis',
  RESEND: 'Renvoyer',
  RESEND_CODE: 'Renvoyer le code',
  RESET_PASSWORD: 'Réinitialiser le mot de passe',
  REVERSED: 'Annulé',
  SAVE: 'Sauvegarder',
  SEARCH: 'Rechercher',
  SEARCH_TRANSACTION_HISTORY: "Recherche dans l'historique des transactions",
  SEARCH_YOU_NETWORK: 'Rechercher un contact',
  SECURITY: 'Sécurité',
  SECURITY_IS_CRITICAL:
    "La sécurité est essentielle pour AFi. Pour aider à protéger votre compte, nous utiliserons un code de vérification pour confirmer qu'il s'agit bien de vous.",
  SECURITY_QUESTION: 'Question de sécurité',
  SELECT_A_COUNTRY: 'Choisir un pays',
  SELECT_ACCOUNT: 'Choisir un compte',
  SELECT_BANK_ACCOUNT: 'Choisir un compte bancaire',
  SELECT_DOCUMENT_TYPE: 'Sélectionnez le type de document',
  SELECT_MOBILE_OPERATOR: 'Choisir un opérateur mobile',
  SELECT_PREFUND_BALANCE: 'Sélectionnez le compte Pré-financer',
  SELECT_PURPOSE_OF_TRANSACTION: 'Sélectionnez le motif de la transaction',
  SELECT_SECURITY_QUESTION: 'Sélectionnez la question de sécurité',
  SEND: 'Envoyer',
  SEND__REQUEST: 'Envoyer / Demander',
  SEND_AND_RECEIVE_COMMERCIAL_PAYMENT:
    'Envoyez et recevez des paiements commerciaux vers, depuis et en Afrique avec AFi.',
  SEND_CODE: 'Envoyer le code',
  SEND_LINK: 'Envoyer le lien',
  SEND_OR_REQUEST_YOUR_FIRST_PAYMENT:
    'Envoyez ou demandez votre premier paiement',
  SEND_PAYMENT: 'Envoyer un paiement',
  SEND_REQUEST: 'Envoyer | Demander',
  SEND_REQUEST_AND_RECEIVE_PAYMENTS:
    ' Envoyer, demander et recevoir des paiements',
  SENDER_NAME: "Nom de l'expéditeur",
  SET_UNIQUE_SECURITY_QUESTION:
    'Définissez une question-réponse de sécurité unique qui est inconnue et ne peut être devinée.',
  SET_UP_TWO_SET: 'Configurer la vérification en deux étapes',
  SETTINGS: 'Paramètres',
  SETUP_RECOVERY_OPTIONS: 'Configurer les options de récupération',
  SHARE_LINK: 'Partager le lien',
  SHARE_THE_PAYMENT_REQUEST: 'Partager la demande de paiement',
  SIGN_IN: 'Se connecter',
  SIGN_UP: "S'inscrire",
  SKIP_FOR_NOW: 'Sauter pour le moment',
  SOCIAL_MEDIA_LINK: 'Lien vers les réseaux sociaux',
  SOMETHING_WENT_WRONG: 'Un problème est survenu. Veuillez réessayer.',
  START_BUILDING_YOUR_NETWORK: 'Ajouter un contact',
  STATE_ID: "Carte d'identité d'État",
  STATE_ID_PHOTO: "Photo de la carte d'identité d'État",
  STATE_REGION: 'État / région',
  STATE_REQUIRED: 'État requis',
  STATUS: 'Statut',
  SUBMIT: 'Soumettre',
  SUBMIT_FOR_APPROVAL: 'Soumettez pour approbation',
  UPLOADING: 'Téléversement...',
  TAX_RECEIPT: 'Reçu fiscal',
  TECHUSTLE_AND_SUBSIDIARIES: 'TecHustle, Inc. et ses filiales.',
  TELEPHONE: 'Numéro de téléphone',
  THE_PAGE_YOU_ARE_LOOKING_FOR:
    "La page que vous recherchez n'existe pas. Comment vous êtes arrivé ici est un mystère. Mais vous pouvez cliquer sur le bouton ci-dessous pour revenir à page d'accueil.",
  THIS_REQUEST_DOES_NOT_EXIST: "Cette demande de paiement n'existe pas",
  THIS_REQUEST_IS_EXPIRED: 'Cette demande a expiré',
  THIS_REQUEST_IS_REVOKED: 'Cette demande est révoquée',
  TITLE_FORGOT_PASSWORD: 'Mot de passe oublié',
  TO: 'À',
  TO_RECOVER_YOUR_ACCOUNT_IF:
    "Pour récupérer votre compte si vous perdez l'accès à votre messagerie ou à votre téléphone, veuillez fournir vos options de sauvegarde",
  TOTAL: 'Total',
  TOTAL_PAID: 'Total payé',
  TRANSACTION_FAILED_STATUS: 'Échoué',
  TRANSACTION_FEES: 'Frais de transaction',
  TRANSACTION_ELEVY_FEES: 'Frais E-levy',
  TRANSACTION_IS_PENDING: 'Cette transaction est en attente',
  TRANSACTION_PENDING_STATUS: 'En attente',
  TRANSACTION_SUCCEEDED_STATUS: 'Réussi',
  TRANSACTION_SUCCESSFUL: 'Génial ! Le paiement a été émis avec succès',
  TRANSACTIONS: 'Transactions',
  TWO_FACTOR_AUTHENTICATION: 'Authentification à deux facteurs',
  UN_VERIFIED: 'Non vérifié',
  UNDERSTAND_HOW_WE_YOUR_DATA:
    'Comprendre comment nous utilisons vos données personnelles.',
  UPDATE_BUSINESS_INFO: "Mise à jour des informations de l'entreprise",
  UPLOAD_A_DOCUMENT: 'Téléverser un document',
  UPLOAD_XLSX: 'Soumettre XLSX',
  UPPER_CASE: 'Majuscule',
  USE_AFI: 'Utiliser AFi',
  USE_ANOTHER_PHONE: 'Utiliser un autre numéro de téléphone',
  USE_YOUR_BANK_ACCOUNT_CARD_AND_MOBILE_MONEY_ACCOUNT:
    'Utilisez votre compte bancaire, votre carte et votre compte mobile money',
  USE_OTHER: "Utiliser d'autres",
  USER_AGREEMENT: "Accord de l'utilisateur",
  VERIFICATION_CODE_HAS_BENN_RESENT: 'Le code de vérification a été renvoyé',
  VERIFICATION_EMAIL_HAS_BEEN_RESENT: "L'e-mail de vérification a été renvoyé",
  VERIFIED: 'Vérifié',
  VERIFY_YOUR_ID: "Vérifiez votre pièce d'identité officielle",
  VERIFY_YOU_BUSINESS: 'Vérifier votre entreprise',
  VERIFY_YOUR_EMAIL: 'Vérifiez votre adresse e-mail',
  VERIFY_YOUR_EMAIL_ADDRESS_AND_TELEPHONE_NUMBER:
    'Vérifiez votre adresse e-mail et votre numéro de téléphone',
  VERIFY_YOUR_IDENTITY: 'Ajouter un compte financier',
  VERIFY_YOUR_IDENTITY_: 'Vérifiez votre identité',
  WE_ARE_AVAILABLE_TO_HELP_YOU:
    'Nous sommes disponibles 24h/24 et 7j/7 pour vous aider !',
  WE_NEED_CAMERA_PERMISSION:
    "Nous avons besoin de l'autorisation de la caméra pour vérifier votre identité",
  WE_SENT_A_PASSWORD_REST_LINK:
    'Nous avons envoyé un lien de réinitialisation du mot de passe',
  WE_SENT_VERIFICATION_MAIL_TO: 'Nous avons envoyé un e-mail de vérification à',
  WEBSITE: 'Site Internet',
  WELCOME: 'Bienvenue',
  WHAT_IS_YOUR_EMAIL_ADDRESS: 'Quelle est votre adresse e-mail?',
  WHERE_SHOULD_THE_PAYMENT_BE_MADE: 'Où le paiement doit-il être effectué?',
  WHICH_BALANCE_DO_YOU_WANT_TO_INCREASE: 'Quel solde souhaitez-vous augmenter ?',
  WHO_ARE_REQUESTING_FROM: 'À qui demandez-vous le paiement?',
  WHO_WOULD_YOU_LIKE_TO_PAY: 'Qui voulez-vous payer?',
  YEAR: 'Année',
  YEAR_REQUIRED: 'Année requise',
  YES_CANCEL: 'Oui, annuler',
  YOU: 'Vous',
  YOU_ARE_ABOUT_TO_DELETE: 'Vous êtes sur le point de supprimer {subject}',
  YOU_ARE_ABOUT_TO_DELETE_FROM_NETWORK:
    'Vous êtes sur le point de supprimer {fullname} de votre réseau',
  YOU_MUST_BE_AT_LEAST: 'Vous devez avoir au moins 18 ans ou plus\n',
  YOU_PAID: 'Vous avez payé ',
  YOU_SEND: 'Vous envoyez',
  YOUR_CURRENT_RECOVERY_IS_SET_TO:
    'Votre récupération actuelle est définie sur {recovery}',
  YOUR_EMAIL: 'Votre email',
  YOUR_MAIL: 'votre e-mail',
  YOUR_PASSWORD_HAS_SUCCESSFULLY_BEEN_RESET:
    'Votre mot de passe a été réinitialisé avec succès',
  YOUR_PAYMENT: 'Votre paiement',
  YOUR_PAYMENT_IS_BEING_PROCESSED:
    'Votre paiement est en cours de traitement. Les demandes seront envoyées une fois le paiement terminé.',
  YOUR_PHONE_NUMBER: 'Votre numéro de téléphone',
  ZIP_CODE: 'B. P.',
  FEES_TITLE: 'Frais',
  BULK_PR_WILL_BE_SENT_TO: 'Les demandes seront envoyées à',
  USERS: 'utilisateurs',
  EACH_ONE_COSTS_YOU: 'Chaque demande vous coûtera',
  TOTAL_FEES: 'Frais totaux',
  SELECT_ACCOUNT_TO_PAY_FEE_WITH:
    'Sélectionnez le compte pour le paiement des frais',
  WE_WILL_CHARGE: 'Nous facturerons',
  YOUR_ACCOUNT: 'votre compte {account}',
  TOTAL_REQUESTED_AMOUNT: 'Montant total demandé',
  INVOICE_STATUS_DRAFT: 'En attente de paiement des frais',
  INVOICE_STATUS_PAID: 'Les demandes de paiement sont émises',
  INVOICE_STATUS_UNPAID: 'Le paiement des frais a échoué',
  INVOICE_STATUS_PENDING: 'Le paiement des frais est en cours de traitement',
  INVOICE_STATUS_SHORT_DRAFT: 'Brouillon',
  INVOICE_STATUS_SHORT_PAID: 'En attente',
  INVOICE_STATUS_SHORT_UNPAID: 'Payé',
  INVOICE_STATUS_SHORT_PENDING: 'Non payé',
  UNABLE_TO_CONFIRM_ACCOUNT_HOLDER_NAME:
    'Impossible de confirmer le nom du titulaire du compte.',
  CHECK_PROVIDED_ACCOUNT:
    'Veuillez vérifier si le {accountNumber} fourni est exact. Si le numéro de compte fourni est exact, vous pouvez fournir un nom de titulaire de compte. Veuillez vous assurer que les détails du compte sont corrects.',
  CHECK_PROVIDED_MOBILE_NUMBER:
    "Nous n'avons pas pu trouver de nom de compte pour ce numéro. Veuillez vérifier que le numéro et l'opérateur mobile sont corrects, puis saisissez le nom du titulaire du compte ci-dessous pour continuer.",
  PHONE_NUMBER_X: 'Numéro de téléphone {phoneNumber}',

  // Login/Signup tabs
  SIGN_IN_WITH_EMAIL: 'E-mail',
  SIGN_IN_WITH_PHONE: 'Numéro de téléphone',
  SIGN_UP_WITH_EMAIL: 'E-mail',
  SIGN_UP_WITH_PHONE: 'Numéro de téléphone',

  // PIN related
  PIN: 'Code PIN',
  ENTER_PIN: 'Entrez le code PIN',
  CONFIRM_PIN: 'Confirmez le code PIN',
  CHOOSE_PIN: 'Choisissez un code PIN à 4 chiffres',
  FORGOT_PIN: 'Code PIN oublié ?',
  PIN_INVALID: 'Le code PIN doit comporter 4 chiffres, pas tous identiques, pas séquentiels et pas un code PIN courant.',
  PINS_DO_NOT_MATCH: 'Les codes PIN ne correspondent pas',
  PIN_REQUIRED: 'Le code PIN est requis',
  CURRENT_PIN: 'Code PIN actuel',
  NEW_PIN: 'Nouveau code PIN',

  // PIN management
  PIN_LOGIN: 'Connexion par code PIN',
  PIN_NOT_SET_UP: 'Non configuré',
  PIN_ACTIVE: 'Actif',
  SET_UP_PIN_LOGIN: 'Configurer la connexion par code PIN',
  CHANGE_PIN: 'Changer le code PIN',
  REMOVE_PIN_LOGIN: 'Supprimer la connexion par code PIN',
  REMOVE_PIN_CONFIRM: "Êtes-vous sûr ? Vous ne pourrez plus vous connecter avec votre numéro de téléphone et votre code PIN.",
  PIN_SETUP_SUCCESS: 'La connexion par code PIN a été configurée avec succès.',
  PIN_CHANGE_SUCCESS: 'Code PIN changé avec succès.',
  PIN_REMOVE_SUCCESS: 'La connexion par code PIN a été supprimée.',

  // Biometric login
  BIOMETRIC_LOGIN: 'Connexion biométrique',
  BIOMETRIC_LOGIN_DESCRIPTION: 'Utilisez Face ID ou Touch ID pour vous connecter plus rapidement',
  BIOMETRIC_NOT_SET_UP: 'Non configuré',
  SET_UP_BIOMETRIC_LOGIN: 'Configurer la connexion biométrique',
  ON: 'Activé',
  OFF: 'Désactivé',
  MULTIPLE_BIOMETRICS_WARNING: "Pour votre sécurité, évitez d'enregistrer plusieurs visages ou empreintes digitales différents sur cet appareil - chacun est un moyen d'accès, et en avoir trop rend plus difficile la détection d'un accès non autorisé.",
  ROOTED_DEVICE_WARNING: "La connexion biométrique n'est pas disponible sur cet appareil.",
  PIN_RESET_SUCCESS: 'Réinitialisation du code PIN réussie. Vous pouvez maintenant vous connecter.',
  VERIFY_PHONE_FIRST: 'Veuillez vérifier votre numéro de téléphone avant de configurer la connexion par code PIN.',

  // Email + Password for phone-only users
  EMAIL_PASSWORD_LOGIN: 'Connexion par e-mail et mot de passe',
  ADD_EMAIL_PASSWORD: 'Ajouter e-mail et mot de passe',
  EMAIL_LOGIN_ACTIVE: 'Actif',
  EMAIL_LOGIN_NOT_SET_UP: 'Non configuré',
  VERIFICATION_EMAIL_SENT: 'E-mail de vérification envoyé. Veuillez vérifier votre boîte de réception.',

  // Recovery
  ADD_RECOVERY_EMAIL_PROMPT: "Nous vous recommandons fortement d'ajouter un e-mail de récupération dans les paramètres.",

  // Phone verification
  PHONE_NUMBER_REQUIRED: 'Le numéro de téléphone est requis',
  SEND_VERIFICATION_CODE: 'Envoyer le code de vérification',
  VERIFY_YOUR_PHONE: 'Vérifiez votre numéro de téléphone',

  // Turnstile / signup bot protection
  CAPTCHA_VERIFICATION_FAILED:
    "Impossible de vérifier que vous n'êtes pas un robot, veuillez réessayer.",
  SIGNUP_THROTTLED:
    "Trop de tentatives d'inscription depuis ce réseau. Veuillez réessayer dans une heure.",
  WAITING_FOR_VERIFICATION: 'En attente de vérification…',
  // Exchange Page
  EXCHANGE_RATES: 'Taux de change',
  LAST_UPDATED: 'Dernière mise à jour',
  DISCLAIMER: 'Avis de non-responsabilité',
  DISCLAIMER_TITLE: 'Avis sur les taux de change',
  DISCLAIMER_INDICATIVE_NOTE:
    'Les taux affichés sur cette page sont indicatifs uniquement. Le taux de change réel appliqué à votre transaction peut différer et sera confirmé au moment de la transaction.',
  DISCLAIMER_RATE_UPDATE_NOTE:
    'Les taux sont actualisés toutes les {interval} minutes.',
  // Rapid Send
  OR_TEXT: 'ou',
  ENTER_VALID_PHONE_NUMBER: 'Veuillez entrer un numéro de téléphone valide',
  // Biometric Feature
  ERROR_FAILED_TO_REMOVE_DEVICE: 'Échec de la suppression des identifiants biométriques de l\'appareil. Veuillez réessayer',
  ERROR_FAILED_BIOMETRIC_VERIFICATION: 'La vérification biométrique a échoué. Veuillez réessayer',
  ERROR_UNKNOWN_ERROR: 'La connexion biométrique n\'est pas prise en charge sur cet appareil',
  BIOMETRICS_NOT_ENROLLED: 'Aucune donnée biométrique n\'est enregistrée sur cet appareil. Veuillez ouvrir l\'application Réglages et enregistrer vos données biométriques',
};

export default fr;
